import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import dayjs from "dayjs";
const offersApi = factory.get("offers");

const initialState = {
  offers: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 100,
      page: 0,
      city_id: null,
      cabinet_id: null,
      is_active: null,
    },
  },
  offer: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      is_all: false,
      is_cabinet: "1",
      cabinet_ids: [],
      city_ids: [],
    },
  },
  new_offer: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      name: null,
      description: null,
      is_active: true,
      account_type_id: null,
      amount: null,
      months_count: null,
      subscriptions_count: null,
      expiry_date: dayjs().format("YYYY-MM-DD"),
      for_new_customers: true,
      for_churn_customers: false,
      for_renewal_customers: false,
      include_client: false,
      city_id: [],
      note: "",
    },
  },
  offer_expiry_date: {
    dialog: false,
    loading: false,
    form: {
      id: "",
      current_expiry_date: dayjs().format("YYYY-MM-DD"),
      expiry_date: null,
    },
  },
  active_offers_list: {
    loading: false,
    list: [],
  },
  all_offers_list: {
    loading: false,
    list: [],
  },
};

const variablesSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {
    setOffers: (state, { payload }) => {
      state.offers.data = payload.data;
      state.offers.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setDialog: (state, { payload }) => {
      if (payload?.id) {
        state.offer.form.id = payload.id;
        state.offer.form.cabinet_ids = payload?.cabinet || [];
        state.offer.form.city_ids = payload?.cities || [];
        state.offer.form.is_all = payload?.is_all ? true : false;
        state.offer.form.is_cabinet = payload?.is_cabinet ? "1" : "0";
      }
      state.offer.dialog = !state.offer.dialog;
      //clear after close
      if (!state.offer.dialog) {
        state.offer.form = initialState.offer.form;
      }
    },
    setFilters: (state, { payload }) => {
      state.offers.filters = {
        ...state.offers.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.offers.filters = initialState.offers.filters;
    },
    setActiveOffersList: (state, { payload }) => {
      state.active_offers_list.list = payload || [];
    },
    setAllOffersList: (state, { payload }) => {
      state.all_offers_list.list = payload || [];
    },
    setOfferDialog: (state, { payload }) => {
      state.new_offer.dialog = !state.new_offer.dialog;
      if (!state.new_offer.dialog) {
        state.new_offer.form = initialState.new_offer.form;
      }
    },
    setOfferExpiryDateDialog: (state, { payload }) => {
      state.offer_expiry_date.form.id = payload?.id || null;
      state.offer_expiry_date.form.id = payload?.id || null;
      state.offer_expiry_date.form.name = payload?.name || null;
      state.offer_expiry_date.form.description = payload?.description || null;
      state.offer_expiry_date.form.current_expiry_date =
        payload?.expiry_date || null;

      state.offer_expiry_date.dialog = !state.offer_expiry_date.dialog;
    },
  },
});

export const {
  setOffers,
  setLoading,
  setDialog,
  setFilters,
  resetFilters,
  setActiveOffersList,
  setOfferDialog,
  setOfferExpiryDateDialog,
  setAllOffersList
} = variablesSlice.actions;

export default variablesSlice.reducer;

const toNumber = (value) => {
  return typeof value === "number" ? value : parseInt(value.replace(/,/g, ""));
};

export const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().offers.offers.filters;
    dispatch(setLoading("offers"));
    const custom_filters = {
      ...filters,
      cabinet_id: filters.cabinet_id?.id || null,
      city_id: filters.city_id?.id || null,
    };
    const res = await offersApi.index(custom_filters);
    dispatch(setOffers(res.data));
    dispatch(setLoading("offers"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors,
        type: "error",
      })
    );
    dispatch(setLoading("offers"));
    throw new Error(err);
  }
};
export const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("new_offer"));
    const city_id = data.city_id.map((item) => item.id);
    await offersApi.create({
      ...data,
      city_id: city_id,
      amount: toNumber(data.amount),
      account_type_id: data.account_type_id?.id,
      note: data?.note || "",
    });
    dispatch(setLoading("new_offer"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setOfferDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("new_offer"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const updateExpiryDate = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("offer_expiry_date"));
    await offersApi.updateExpiryDate(data);
    dispatch(setLoading("offer_expiry_date"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setOfferExpiryDateDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("offer_expiry_date"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const updateCabinets = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("offer"));
    const cabinet_ids =
      data.cabinet_ids?.length > 0
        ? data.cabinet_ids.map((item) => item.id)
        : [];
    const city_ids =
      data.city_ids?.length > 0 ? data.city_ids.map((item) => item.id) : [];

    await offersApi.update(data.id, {
      is_all: data.is_all ? 1 : 0,
      is_cabinet: data.is_cabinet === "1" ? 1 : 0,
      cabinet_ids: data.is_all || data.is_cabinet !== "1" ? [] : cabinet_ids,
      city_ids: data.is_all || data.is_cabinet === "1" ? [] : city_ids,
    });

    dispatch(setLoading("offer"));
    dispatch(
      showNotification({
        message: "تم الحفظ بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("offer"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const toggleActive = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("offers"));
    await offersApi.toggleActive(id);
    dispatch(setLoading("offers"));
    dispatch(
      showNotification({
        message: "تم تغيير الحالة بنجاح",
        type: "success",
      })
    );
    dispatch(index());
  } catch (err) {
    dispatch(setLoading("offers"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
export const activeOffersList = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("active_offers_list"));
    const res = await offersApi.activeOffersList();
    dispatch(setActiveOffersList(res.data.data));
    dispatch(setLoading("active_offers_list"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors,
        type: "error",
      })
    );
    dispatch(setLoading("active_offers_list"));
    throw new Error(err);
  }
};
export const allOffersList = () => async (dispatch) => {
  try {
    dispatch(setLoading('all_offers_list'))
    const res = await offersApi.allOffersList();
    dispatch(setAllOffersList(res.data.data));
    dispatch(setLoading('all_offers_list'))
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors,
        type: "error",
      })
    );
  }
};



export const OffersActions = {
  index,
  create,
  updateCabinets,
  toggleActive,
  activeOffersList,
  updateExpiryDate,
  allOffersList
};
